import { Routes, Route, useLocation, Navigate, useParams } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import Layout from '@/components/layout/Layout'
import HomePage from '@/pages/HomePage'
import ProjectPage from '@/pages/ProjectPage'
import VodafonePage from '@/pages/VodafonePage'
import TobiPage from '@/pages/TobiPage'
import NotFoundPage from '@/pages/NotFoundPage'
import { useScrollManager } from '@/hooks/useScrollManager'
import { useDocumentHead } from '@/hooks/useDocumentHead'

function LegacyProjectRedirect() {
  const { slug } = useParams<{ slug: string }>()
  return <Navigate to={`/project/${slug}`} replace />
}

function App() {
  const location = useLocation()
  useScrollManager()
  useDocumentHead()

  return (
    <Layout>
      <AnimatePresence mode="wait" initial={false}>
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<HomePage />} />
          <Route path="/project/vodafone" element={<VodafonePage />} />
          <Route path="/project/tobi" element={<TobiPage />} />
          <Route path="/project/:slug" element={<ProjectPage />} />
          <Route path="/project-detail-:slug" element={<LegacyProjectRedirect />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AnimatePresence>
    </Layout>
  )
}

export default App
